export function scrollList() {
document.querySelectorAll("[data-scroll-list]").forEach((list) => {
  const active = list.querySelector(".active");
  if (!active) return;

  const offset = parseInt(window.getComputedStyle(list).paddingLeft);
  list.scrollLeft += active.getBoundingClientRect().left - offset;
});
}